import { Component, Inject, OnInit, ViewChild, EventEmitter} from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DValorDominio } from '@dian/api-basicos-parametricas';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_228';

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Lista de dependientes económicos', listHelp: ['668'] }
];

const tableStructure = [
  {id: 'nomTipoDoc', title: 'Tipo de documento'}, 
  {id: 'numDoc', title: 'Número de documento'},
  {id: 'nomParentesco', title: 'Parentesco'},
];

class ValoresDominio {
  valor: string;
  nombre: string;
  mostrar: boolean;
}

class Form1 {
id: number;
tipoDoc: string;
nomTipoDoc: string;
numDoc: string;
parentesco: string;
nomParentesco: string;
}

@Component({
  selector: 'app-beneficios-dependientes-modal',
  templateUrl: './beneficios-dependientes-modal.component.html',
  styleUrls: ['./beneficios-dependientes-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class BeneficiosDependientesModalComponent extends HandlerModal implements OnInit {
  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  tiposDocumento: ValoresDominio[] = [];
  tiposParentesco: DValorDominio[] = [];
  public OPERACION_NULA:number = 0;
  public OPERACION_AGREGAR:number = 1;
  public OPERACION_EDITAR:number = 2;
  public OPERACION_BORRAR:number = 3; 
  public operacionTabla:number = this.OPERACION_NULA;
  mensajeTabla = "Solo puede agregar hasta 4 personas como dependientes económicos.";

  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  public showSave:boolean;

  tiposDocumentoFiltrados: ValoresDominio[] = [];

  constructor(
    public dialogRef: MatDialogRef<BeneficiosDependientesModalComponent>,
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    console.log(model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();

    //console.log(this.tiposDocumento);

    this.filtroTipoDocumento();
    
  }

  protected inicializeForm(){
    this.modelForm = new Form1();
    this.modelForm.id=0;
    this.modelForm.tipoDoc="";
    this.modelForm.nomTipoDoc='';
    this.modelForm.numDoc="";
    this.modelForm.parentesco="";
    this.modelForm.nomParentesco="";

  }
  

  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cc_id_669 == undefined){

      this.model.doc.cuerpo.cc_id_669 = []; 
      this.model.doc.cuerpo.cc_id_670 = [];
      this.model.doc.cuerpo.cc_id_671 = [];
    }  
  }

  //método para filtrar los tipos de documentos
  protected filtroTipoDocumento(){

    const valoresPermitidos = ['11', '12', '13', '14', '21', '22', '41', '42', '47', '48'];

    this.tiposDocumento.forEach(item => {
      item.mostrar = valoresPermitidos.includes(item.valor);
    });

    this.tiposDocumentoFiltrados = this.tiposDocumento.filter(item => item.mostrar);

  }
  
  protected initializeTablaDesdeModelo(){
    this.dataSourceBody = [];
    //for(let i=0; i<this.model.doc.cuerpo.cc_id_669.length; i++){
      for(let i=0; i<this.model.doc.cuerpo.cc_id_670.length; i++){
      this.modelForm.id=i;
      this.modelForm.tipoDoc=this.model.doc.cuerpo.cc_id_669[i].v;
      //if(this.tiposDocumento && this.tiposDocumento.length>0)
      if(this.model.doc.cuerpo.cc_id_669[i].v)
        this.modelForm.nomTipoDoc = this.tiposDocumento.find(elemento => elemento.valor === this.model.doc.cuerpo.cc_id_669[i].v).nombre;
      this.modelForm.numDoc=this.model.doc.cuerpo.cc_id_670[i].v;
      this.modelForm.parentesco=this.model.doc.cuerpo.cc_id_671[i].v; 
      //if(this.tiposParentesco && this.tiposParentesco.length>0)
      if(this.model.doc.cuerpo.cc_id_671[i].v)  
        this.modelForm.nomParentesco = this.tiposParentesco.find(elemento => elemento.valor === this.model.doc.cuerpo.cc_id_671[i].v).nombre;
      
      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }
  
  public editModeloDesdeForm(){
    this.model.doc.cuerpo.cc_id_669[this.modelForm.id].v=this.modelForm.tipoDoc.toString();
    this.model.doc.cuerpo.cc_id_670[this.modelForm.id].v=this.modelForm.numDoc.toString();
    this.model.doc.cuerpo.cc_id_671[this.modelForm.id].v=this.modelForm.parentesco.toString();
  }
  
  public addToModeloDesdeForm(){
    let i= this.modelForm.id+1;
    this.model.doc.cuerpo.cc_id_669.push({it: i, v:this.modelForm.tipoDoc});
    this.model.doc.cuerpo.cc_id_670.push({it: i, v:this.modelForm.numDoc.toString()});
    this.model.doc.cuerpo.cc_id_671.push({it: i, v:this.modelForm.parentesco.toString()});
  }

  public deleteOnModel(index:number){
    this.model.doc.cuerpo.cc_id_669.splice(index,1);
    this.model.doc.cuerpo.cc_id_670.splice(index,1);
    this.model.doc.cuerpo.cc_id_671.splice(index,1);

    //reenumerear it
    for(let i=0;i<this.model.doc.cuerpo.cc_id_669.length;i++){
      this.model.doc.cuerpo.cc_id_669[i].it=i+1;
      this.model.doc.cuerpo.cc_id_670[i].it=i+1;
      this.model.doc.cuerpo.cc_id_671[i].it=i+1;
    }
  }

  public validateFormCompleted():boolean{
    return this.modelForm.tipoDoc==undefined || this.modelForm.tipoDoc==null || this.modelForm.tipoDoc.trim()=="" ||
        this.modelForm.numDoc==undefined || this.modelForm.numDoc==null || this.modelForm.numDoc.trim()=="" || 
        this.modelForm.numDoc ==='0' || this.modelForm.numDoc.length <=3 ||
        this.modelForm.parentesco==undefined || this.modelForm.parentesco==null || this.modelForm.parentesco.trim()=="" 
  }

  //método para verificar que sean hasta 4 dependientes
  public esMayorQueCuatro(array: any[]):boolean{
    return array.length > 3;
  }
 
  saveItem(): void {
    if(this.validateFormCompleted()){
      if( this.modelForm.numDoc ==='0' || this.modelForm.numDoc.length <=3)
       {
        const dialogError1 = this.dNotificacionServicio.mostrarDialogoError("Número de documento no valido" );
       }
      else
      {
        const dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro" );
      }
      return;
    }else{

      //this.redondearFormData();
      if (this.operacionTabla==this.OPERACION_EDITAR){
        //this.editModeloDesdeForm();

        let tipoDoc2 = this.tiposDocumento.find(elemento => elemento.valor === this.modelForm.tipoDoc);
        let tipoParentesco = this.tiposParentesco.find(elemento => elemento.valor === this.modelForm.parentesco);

        this.modelForm.nomTipoDoc = tipoDoc2.nombre;
        this.modelForm.nomParentesco = tipoParentesco.nombre;

        this.dataSourceBody.forEach((el)=>{
          if(el.id == this.modelForm.id){
            el=this.modelForm;
          }
        });

      }else if (this.operacionTabla==this.OPERACION_AGREGAR){
        
        //Nueva validación para verificar que sean hasta 4 dependientes
        if (this.esMayorQueCuatro(this.dataSourceBody)) {
           let dialogError = this.dNotificacionServicio.mostrarDialogoError("Solo puede agregar hasta 4 personas como dependientes económicos.");
          return;
        }
        
        //this.modelForm.id = this.dataSourceBody.length;
        this.modelForm.id = this.model.doc.cuerpo.cc_id_669.length;
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();

        let tipoDoc2 = this.tiposDocumento.find(elemento => elemento.valor === this.modelForm.tipoDoc);
        let tipoParentesco = this.tiposParentesco.find(elemento => elemento.valor === this.modelForm.parentesco);

        this.modelForm.nomTipoDoc = tipoDoc2.nombre;
        this.modelForm.nomParentesco = tipoParentesco.nombre;

      }
      
      this.inicializeForm();
      this.operacionTabla=this.OPERACION_NULA;
      //console.log(this.model);
    }
  }

  eventTable($event: string): void {
    if($event === 'add') this.operacionTabla=this.OPERACION_AGREGAR;
    if($event === 'edit') this.operacionTabla=this.OPERACION_EDITAR;
    if($event === 'delete') this.operacionTabla=this.OPERACION_BORRAR;

  }

  updateItemSelected($event: any): void {
    let index = $event;
    if(this.operacionTabla==this.OPERACION_EDITAR){//editando
      this.modelForm = this.dataSourceBody[index];
    }
    if(this.operacionTabla==this.OPERACION_BORRAR){//borrando
      //this.deleteOnModel(index);
      this.operacionTabla=this.OPERACION_NULA;
    }
  }
  
  cancel(): void {
    this.inicializeForm();
    this.operacionTabla=this.OPERACION_NULA;
  }

  
  protected controlStep(direction: DirectionType): void {
   
  }


  public closeModal(){
    this.initializeTablaDesdeModelo();
    this.dialogRef.close("");
  }

  public guardar(){
    //Limpiar modelo y agregar el contenido de la tabla
    //if(this.model.doc.cuerpo.cc_id_582.length != this.dataSourceBody.length){ 
    this.model.doc.cuerpo.cc_id_669 = undefined;
    this.inicializeModelo();
    for(let i=0; i<this.dataSourceBody.length; i++){
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm(); 
    }
        
    this.saveModel.emit(true);
    this.closeModal();

  }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/beneficios-tributarios/beneficios-dependientes-modal/beneficios-dependientes-modal.component.ts